module.exports = __webpack_public_path__ + "Coloring-8a404fab70ad499da2f598bd0d6df246.svg";